import BigNumber from 'bignumber.js';
import { SingleDrawLotteryStatus } from '@/services/lottery';

export type GroupReward = {
  rewardToken: string;
  totalAmount: string;
  tokenIcon: string;
};

export const getGroupRewards = (
  rewards: SingleDrawLotteryStatus[]
): GroupReward[] => {
  const groupedMap = rewards.reduce((acc, curr) => {
    const key = curr.rewardToken;
    if (!acc.has(key)) {
      acc.set(key, {
        rewardToken: curr.rewardToken,
        totalAmount: '0',
        tokenIcon: curr.tokenIcon,
      });
    }

    const current = acc.get(key)!;
    const newTotal = new BigNumber(current.totalAmount)
      .plus(new BigNumber(curr.amount))
      .toString();

    acc.set(key, {
      ...current,
      totalAmount: newTotal,
    });

    return acc;
  }, new Map<string, GroupReward>());

  return Array.from(groupedMap.values());
};
